<template>
<div>
    <MbReportTabs selected="subprocess" :userId="userId"/>

    <div class="row">
        <div class="col-12 col-lg-10 mx-auto">
            <p v-if="subprocess.length == 0" class="text-center">
                Non è stata svolta nessuna attività, per questo non è disponibile nessun report.
            </p>
            <div v-else class="row">
                <div class="col-lg-9">
                    <div v-if="displayChart" id="chart_div" style="width:100%; height:500px;"></div>
                    <p v-else class="text-center">
                        Nessun dato trovato per i parametri impostati.
                    </p>

                    <div class="mt-5 report-filters">
                        <div v-for="(row, rk) in subprocess" :key="rk" class="form-check">
                            <input 
                                :style="'background-color: #' + colors[rk] + ';'"
                                :id="'checkFilter1' + rk"
                                class="form-check-input" 
                                type="checkbox" 
                                v-model="form.subprocess"
                                :value="row.value"/>
                            <label class="form-check-label" :for="'checkFilter1' + rk" v-html="row.label"></label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">   
                    <div class="report-summary">
                        <div class="row mb-5 mx-auto">
                            <div class="col-6">
                                DAL
                                <input v-model="form.dateFrom" type="date" class="form-control" /> 
                            </div>
                            <div class="col-6">
                                AL
                                <input v-model="form.dateTo" type="date" class="form-control" /> 
                            </div>
                        </div>

                        <div class="mb-3 border p-3 filter-container">
                            <h4>Attività in studio</h4>
                            
                            Attività: <span class="fw-bolder">{{summary.local.attivita}}</span><br/>
                        
                            Esercizi: <span class="fw-bolder">{{summary.local.esercizi}}</span><br/>
                            
                            Prima: <span class="fw-bolder">{{summary.local.prima}}</span><br/>
                            
                            Ultima: <span class="fw-bolder">{{summary.local.ultima}}</span>
                        </div>
                        
                        <div class="mb-3 border p-3 filter-container">
                            <h4>Attività a distanza</h4>

                            Attività: <span class="fw-bolder">{{summary.remote.attivita}}</span> <br/>
                        
                            Esercizi: <span class="fw-bolder">{{summary.remote.esercizi}}</span> <br/>
                            
                            Prima: <span class="fw-bolder">{{summary.remote.prima}}</span> <br/>
                        
                            Ultima: <span class="fw-bolder">{{summary.remote.ultima}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios"
import MbReportTabs from "./MbReportTabs.vue"

export default {
    components: {
        MbReportTabs
    },
    props: {
        colors: Array,
        subprocess: Array,
        dateFrom: Date,
        dateTo: Date,
        summary: Object,
        userId: Number
    },
    data(){
        return {
            displayChart: true,
            form: {
                dateFrom: '',
                dateTo: '',
                subprocess: []
            }
        }
    },
    computed: {
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.updateChart()
            }
        }
    },
    mounted(){
        this.form.dateFrom = this.dateFrom
        this.form.dateTo = this.dateTo

        if (this.subprocess.length > 0){
            for(let sp of this.subprocess){
                this.form.subprocess.push(sp.value)
            }

            window.google.load('visualization', '1', {'packages':['corechart']})
            window.google.setOnLoadCallback(this.updateChart())
        }
    },
    methods: {
        updateChart(){
            axios.post('/structure/student/report/UserSubprocessStatsAction-jsonGraph?outFormat=json', {
                subprocess: this.form.subprocess,
                date1: this.form.dateFrom,
                date2: this.form.dateTo,
                userId: this.userId
            })
                .then((response) => {
                    this.renderChart(response)
                })
                .catch((error) => {
                    alert(error)
                })

            return true
        },
        renderChart(response){
            if (response.data.chart.rows.length == 0){
                this.displayChart = false
                return
            }

            this.displayChart = true
            this.$nextTick(() => {
                let data = new window.google.visualization.DataTable(response.data.chart)

                let colors = []
                for (let i = 0; i < this.subprocess.length; i++){
                    if (this.form.subprocess.indexOf(this.subprocess[i].value) !== -1){
                        colors.push(this.colors[i])
                    }
                }

                var options = {
                    title: 'Correttezza (%)',
                    colors: colors,
                    pointSize: 3,
                    legend: {position: 'none'},
                    chartArea: {left: 50, top: 20, width: '100%', height: '90%' },
                    vAxis: {
                            viewWindow:{
                                max: 110,
                                min : 0
                            }
                    }
                };

                var chart = new window.google.visualization.LineChart(document.getElementById('chart_div'))
                chart.draw(data, options)
            })           
        }
    }
}
</script>
<style scoped>
.inline-block{
    display: inline-block;
}
</style>